import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { LocalizationProvider } from "@mui/lab";
import { Stack, TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "axios";
import moment from "moment";
import Multiselect from "multiselect-react-dropdown";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import cup from "../../../assets/images/page 1.png";
import "./PostContentMaking.css";

const SuperStarPromoCreate = () => {
  const { slug } = useParams();
  const [file, setFile] = useState("");
  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [filePdf, setFilePdf] = useState("");
  const [videoFile, setVideoFile] = useState("");

  const [events, setEvents] = useState([]);
  const [audition_id, setAuditionId] = useState("");
  const [judges, setJudges] = useState([]);
  const [convertedContent, setConvertedContent] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const history = useHistory();

  useEffect(() => {
    axios.get(`/api/audition-admin/audition/events`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.events);
      }
    });
  }, []);

  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleVideoChange = (file) => {
    setFileVideo(file[0]);
    setVideoFile(URL.createObjectURL(file[0]));
  };

  const handlePdfChange = (file) => {
    setFilePdf(file[0]);
  };

  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());

  const [items, setItems] = useState([]);

  const handleSelect = (selectedList) => {
    setItems(selectedList);
  };

  const handleRemove = (selectedList) => {
    setItems(selectedList);
  };

  const handleChange = (event) => {
    setAuditionId(event.target.value);
    axios
      .get(`/api/audition-admin/audition-event/audition_single_by_id/${event.target.value}`)
      .then((res) => {
        if (res.data.status === 200) {
          let judges_array = [];
          res.data.event.assigned_judges.forEach((judge, index) => {
            let user = judge?.user;
            judges_array.push({
              name: user.first_name + " " + user.last_name,
              id: user.id,
            });
          });
          setJudges(judges_array);
        }
      });
  };

  const submitPostMakingContent = (e) => {
    e.preventDefault();
    const fData = new FormData();
    fData.append("audition_id", audition_id);
    if (items.length > 0) {
      items.forEach((item) => {
        fData.append("star_ids[]", Number(item.id));
      });
    }
    fData.append("instruction", convertedContent);
    fData.append("video", fileVideo);
    fData.append("image", imageData);
    fData.append("pdf", filePdf);
    fData.append("start_date", moment(startDate).format("YYYY-MM-DD"));
    fData.append("end_date", moment(endDate).format("YYYY-MM-DD"));

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/super-star-promo/store`, fData)
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            history.goBack();
          } else {
            setErrorList(res.data.validation_errors);
          }
        });
    });
  };

  return (
    <>
      <div className="card card-bg head-line mb-2 mb-2">
        <div className="text-light d-flex justify-content-center p-2">
          <div className="faTrophy">
            <img src={cup} alt="" width="30px" />
          </div>
          <h4 className="mx-3 text-white p-2">
            Content Making Requirements for Star
          </h4>
        </div>
      </div>

      <div className="card-bg">
        <div className="container mb-5 mt-4 card-bg py-4">
          <div className="my-2">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  onSubmit={submitPostMakingContent}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="row ms-5">
                    <div className="form-group row mt-3">
                      <label
                        for="staticEmail"
                        className="col-sm-3 col-form-label text-warning fw-bold "
                      >
                        Select An Audition
                      </label>
                      <div className="col-sm-9">
                        <select
                          onChange={handleChange}
                          className="form-select form-control reply-control text-black"
                          aria-label="Default select example"
                          id="audition_id"
                          name="audition_id"
                        >
                          <option value="0">--Select Audition--</option>
                          {events.map((event, index) => (
                            <option key={index} value={event.id}>
                              {event.title}
                            </option>
                          ))}
                        </select>
                        <span className="text-danger">
                          {errorList.audition_id}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="inputPassword"
                        className="col-sm-3 col-form-label text-warning fw-bold "
                      >
                        Description
                      </label>
                      <div className="col-sm-7">
                        <CKEditor
                          editor={ClassicEditor}
                          data={convertedContent}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setConvertedContent(data);
                          }}
                          onBlur={(event, editor) => {}}
                          onFocus={(event, editor) => {}}
                        />
                        <span className="text-danger">
                          {errorList.instruction}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="staticEmail"
                        className="col-sm-3 col-form-label text-warning fw-bold "
                      >
                        Select Superstar
                      </label>
                      <div className="col-sm-9">
                        <Multiselect
                          options={judges}
                          selectedValues={items}
                          onSelect={handleSelect}
                          onRemove={handleRemove}
                          className="from-control reply-control"
                          displayValue="name"
                        />
                        <span className="text-danger">
                          {errorList.star_ids}
                        </span>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-12 my-2 row">
                        <div className="col-md-3">
                          <label
                            for="staticEmail"
                            className="col-form-label text-warning fw-bold"
                          >
                            Upload Video
                          </label>
                        </div>
                        <div className="col-md-5 ms-1">
                          {videoFile ? (
                            <>
                              <ReactPlayer
                                url={videoFile}
                                className="width-img"
                                controls={true}
                              />
                            </>
                          ) : (
                            <></>
                          )}
                          <input
                            type="file"
                            name="file"
                            id="setFile"
                            className="inputfile w-25"
                            accept="video/mp4"
                            onChange={(e) => handleVideoChange(e.target.files)}
                          />

                          <label for="setFile">
                            <i className="fas fa-cloud-upload-alt"></i> Upload
                            Video
                          </label>
                          <span className="text-danger">{errorList.video}</span>
                        </div>
                      </div>

                      <div className="col-md-12 my-2 row">
                        <div className="col-md-3">
                          <label
                            for="staticEmail"
                            className="col-form-label text-warning fw-bold"
                          >
                            Upload Banner
                          </label>
                        </div>
                        <div className="col-md-5 ms-1">
                          {file ? (
                            <img
                              src={file}
                              alt="..."
                              className="demo-preview-image img-fluid"
                            />
                          ) : (
                            ""
                          )}
                          <input
                            type="file"
                            name="imageFile"
                            id="imageFile"
                            className="inputfile w-25"
                            accept="image/jpg,image/jpeg, image/png"
                            onChange={(e) => handleImageChange(e.target.files)}
                          />

                          <label for="imageFile">
                            <i className="fas fa-cloud-upload-alt"></i> Upload
                            Banner
                          </label>
                          <span className="text-danger">{errorList.image}</span>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-md-12 row">
                        <div className="col-md-3">
                          <label
                            for="staticEmail"
                            className="col-form-label text-warning fw-bold"
                          >
                            Content Submission Start Date
                          </label>
                        </div>
                        <div className="col-md-5 ms-1 dateParentPicker timeLengthPicker ">
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Stack spacing={3}>
                              <DatePicker
                                disablePast
                                label="Start Date"
                                openTo="day"
                                views={["year", "month", "day"]}
                                value={startDate}
                                onChange={(newValue) => {
                                  setStartDate(newValue);
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              />
                            </Stack>
                          </LocalizationProvider>
                          <span className="text-danger">
                            {errorList.start_date}
                          </span>
                        </div>
                      </div>

                      <div className="col-md-12 my-2 row">
                        <div className="col-md-3">
                          <label
                            for="staticEmail"
                            className="col-form-label text-warning fw-bold"
                          >
                            Content Submission End Date
                          </label>
                        </div>
                        <div className="col-md-5 ms-1 dateParentPicker timeLengthPicker">
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Stack spacing={3}>
                              <DatePicker
                                disablePast
                                label="End Date"
                                openTo="day"
                                views={["year", "month", "day"]}
                                value={endDate}
                                onChange={(newValue) => {
                                  setEndDate(newValue);
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              />
                            </Stack>
                          </LocalizationProvider>
                          <span className="text-danger">
                            {errorList.end_date}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-12 row">
                        <div className="col-md-3">
                          <label
                            for="staticEmail"
                            className="col-form-label text-warning fw-bold"
                          >
                            Instruction pdf for the post
                          </label>
                        </div>
                        <div className="col-md-5 ms-1">
                          <input
                            type="file"
                            name="pdfFile"
                            id="pdfFile"
                            accept=".pdf"
                            className="inputfile w-25"
                            onChange={(e) => handlePdfChange(e.target.files)}
                          />
                          <label for="pdfFile">
                            <i className="fa-solid fa-file-pdf"></i> 1 MB
                            Maximum
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="row my-4">
                      <div className="col-md-3 mx-auto">
                        <button
                          className="btn btnConfirm w-100 px-4 fw-bold"
                          type="submit"
                        >
                          Confirm
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuperStarPromoCreate;
